import React, { useState, useRef, useEffect,useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactTabulator } from 'react-tabulator';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
import { jwtDecode } from 'jwt-decode';
import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';
import Acct_001_01 from './acct_001_01'
import CustomToast from '../../components/toast/toast.jsx';
import { API_BASE_URL } from '../../config/app-axios.jsx';
import { clearUserState } from '../../reducers/userReducers.jsx';
import { clearMenuState } from '../../reducers/menuReducers.jsx';
import { clearLangCodeState } from '../../reducers/langCodeReducers.jsx';
import { getUserInfo } from '../../reducers/selectors/selectors.jsx';
import { store } from '../../store.jsx';

// 모계좌관리
const Acct001 = () => {
	const { t,i18n }  = useTranslation();
	const dispatch    = useDispatch();
    const tableRef    = useRef(null);

	// 초기 값
	const [loading, setLoading]                       = useState(false);
	const [rowsPerPage, setRowsPerPage]               = useState(20);
	const [filterField, setFilterField]               = useState('bank_name');
	const [filterType, setFilterType]                 = useState('like');
	const [filterValue, setFilterValue]               = useState('');
	const [detailData, setDetailData]                 = useState([]);
	const [totalCount, setTotalCount]                 = useState(0);

	// 모달폼오픈
	const [showModal, setShowModal] 	= useState(false);
	const [accountNoId, setAccountNoId] = useState('')

	// 토스트
	const [toast, setToast] = useState(false);
	const [text, setText]   = useState('');

	// remote 방식에 따른 페이징 처리
	const apiUrl                                      = API_BASE_URL;
	const userInfo                                    = getUserInfo(store.getState());
	const [branchType, setBranchType]                 = useState(userInfo.branch_type);
	const token                                       = userInfo?.access_token;
	const [selectBranch,setSelectBranch]              = useState('');
	const [selectOptions1,setSelectOptions1]          = useState([]);

	// 지점 정보 변경
	const handleChangeBranch = (e) => {
		setSelectBranch(e.target.value);
	};

	// ①. 강제로 쿠키 삭제를 통한 로그인 정보가 없는 경우
    const persistInfo = sessionStorage.getItem('persist:login');

    if (!persistInfo) {
        window.location.href = '/login';
    };

	// ②. 토큰 만료 체크 루틴
	if (token) {
		const decodedToken            = jwtDecode(token);
		const expirationTimeInSeconds = decodedToken.exp;
		const currentTimeInSeconds    = Math.floor(Date.now() / 1000);

		if (expirationTimeInSeconds < currentTimeInSeconds) {
			// 토큰이 만료되었을 경우 로그인 페이지로 리디렉션
			dispatch(clearUserState());
			dispatch(clearMenuState());
			dispatch(clearLangCodeState());
			localStorage.removeItem('langCodeInfo');
			window.location.href = '/login';
		};
	};

	// Cell 클릭 이벤트(수정)
	const handleCellClick = async (rowData) => {
		try {
			// ReactTabulator에서 사용하는 API URL과 Params를 사용하여 호출
			const url  = new URL(options.ajaxURL);
			url.search = new URLSearchParams({
				...options.ajaxParams,
				AccountNo    : rowData.account_no,
				page         : tableRef?.current.getPage(),     // 현재 페이지 정보
				size         : tableRef?.current.getPageSize(), // 페이지 크기 정보
				branch_code  : selectBranch
			});

			const data = await fetch(url, {
				method  : options.ajaxConfig.method,
				headers : options.ajaxConfig.headers,
			});

			const responseData = await data.json();

			setDetailData(responseData.data)

			setLoading(false);

		} catch (error) {
			console.error('Error in fetchAcct001MotherAcctDetail : ', error);
			setLoading(false);
		} 

		setShowModal(true);
	}

	// 모달창오픈
	const handleButtonClick = () => {
		setDetailData([]);
		setShowModal(true);
	}
	
	const handleClose = () => {
		setDetailData([]);
		setShowModal(false);
		handleQuery();
	}

	// 계좌번호
	const handleChangeAccountNo = (e) => {
		setAccountNoId(e.target.value);
	};

	const [BranchCodeOptions, setBranchCodeOptions] = useState([]);	  // 지점
	const [BankCodeOptions, setBankCodeOptions] 	= useState([]);   // 은행 

	useEffect(() => {
		const fetchBaseOptions = async () => {
			try {
				const data = await API.fetchBaseOptions();

				const options1  = data.filter(item => item.code_nick_name === '지점');
				const SelectOptions = options1.map(item => [item.code,item.code_se]);

				if (SelectOptions.length === 1) {
					setSelectBranch(SelectOptions[0][0]);
				};
				
				
				const options2 = data.filter(item => item.code_nick_name === '은행');
				options2.sort((a, b) => a.code_se.localeCompare(b.code_se)); 
				const BankCodeOptions = options2.map(item => [item.code, item.code_se]);
				
				setSelectOptions1(SelectOptions);
				setBranchCodeOptions(SelectOptions)
				setBankCodeOptions(BankCodeOptions);


			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		fetchBaseOptions();
	}, []); // 빈 배열은 컴포넌트가 마운트될 때 한 번만 실행

	// Tabulator Options
	// options 객체를 상태로 관리
	const [options, setOptions] = useState({
		ajaxURL     : `${apiUrl}/acct/acct_001`,
		ajaxConfig  : {
			method  : 'GET',
			headers : {
				'Content-Type' : 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		},
		ajaxParams : {
			page : tableRef.current && tableRef.current.table ? tableRef.current.getPage() : 1,
			size : tableRef.current && tableRef.current.table ? tableRef.current.getPageSize() : 20, // 페이지 크기 정보
		},
		layout                 : "fitColumns",
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage,
		paginationSizeSelector : [20, 40, 60, 80, 100],
		ajaxResponse : function (url, params, response) {

			// 값이 변경되면 직접 타이핑 하는 계좌번호 칸은 초기화시키기
			setAccountNoId('');

			const total_count    = response.total_count || 0;
			const responseData   = {
				last_page : response.last_page,
				data      : response.data,
			};

			setTotalCount(total_count);

			return responseData;
		}
	});

	// 조회 조건이 바뀜에 따라 ajaxParams 동적 변경
	useEffect(() => {
		setOptions((prevOptions) => {
			const updatedOptions = {
				...prevOptions,
				ajaxParams: {
					...prevOptions.ajaxParams,
					branch_code             : selectBranch
				},
			};
			return updatedOptions;
		});
	}, [selectBranch]);

	// 로딩 중일 때 이전의 pagination 관련 정보를 유지하도록 설정
	const loadingOptions = {
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage, // 이전 페이지 사이즈를 유지
		paginationSizeSelector : [20, 40, 60, 80, 100],
	};

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = useCallback(
		async () => {
			setLoading(true);

			// ReactTabulator의 내부 로직을 사용하여 API 호출
			try {
				// ReactTabulator에서 사용하는 API URL과 Params를 사용하여 호출
				const url  = new URL(options.ajaxURL);
				url.search = new URLSearchParams({
					...options.ajaxParams,
					AccountNo : accountNoId,
					page      : tableRef.current?.getPage(),     // 현재 페이지 정보
					size      : tableRef.current?.getPageSize(), // 페이지 크기 정보
				});

				const data = await fetch(url, {
					method  : options.ajaxConfig.method,
					headers : options.ajaxConfig.headers,
				});

				const responseData = await data.json();

				// 전달 받은 총 데이터 건수
				const total_count = responseData.total_count || 0;
		
				// 페이징 및 데이터 리턴
				const updatedData = {
					last_page : responseData.last_page, // 전체 페이지 수 계산
					data      : responseData.data,      // 실제 테이블 데이터
				};

				// 총 건수를 화면에 표현하기 위해서
				setTotalCount(total_count);

				// 데이터 변경
				if (tableRef.current) {
					tableRef.current.setData(updatedData.data || []);
				}

			} catch (error) {
				console.error('Error in fetchAcct001Data : ', error);
			} finally {
				setLoading(false);  // API 요청 완료 후 로딩 상태 해제
			}
		}, [options, accountNoId]
	);

	// 잔액조회 버튼 액션
	const handleAccountApi = async () => {
		// Tabulator에서 선택된 항목이 있는지 확인
		const selectedData = tableRef.current.getSelectedData();

		// 체크 루틴
		if (selectedData.length === 0) {
			alert("선택된 항목이 없습니다.");
			return;
		}

		setLoading(true);
	
		// 선택된 행이 있는 경우 API 호출 부분
		try {
			// console.error('계좌 조회 시작');
			const data = await API.bankGetAccount();
			// console.error('계좌 조회 종료:', data);
			if (!data.Amount) {
				alert(data.error);
				setLoading(false);
				return;
			} else {
				handleQuery();
				setText("잔액 조회 성공");
				setToast(true);
			}
		} catch (error) {
			console.error('Error in fetchAcctDataUpdateState:', error);
		} finally {
			setLoading(false);  // API 요청 완료 후 로딩 상태 해제
		}
	};

	useEffect(() => {
		setColumns(titleColunms(t))
	}, [i18n.language, t,handleQuery]);

// Tabulator columns 목록
	const titleColunms = (t) => {
		return [
			{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
				cell.getRow().toggleSelect();
			}},				
			{ title: t('COLLECTION_MANAGEMENT.은행', { defaultValue: '은행' }), field: 'bank_name', headerHozAlign: 'center', hozAlign: 'center', width: 200 },
			{ title: `<i class="fa-solid fa-link"></i> ${t('COLLECTION_MANAGEMENT.계좌번호', { defaultValue: '계좌번호' })}`, field: 'account_no', headerHozAlign: 'center', hozAlign: 'center', width:200 ,
				formatter: function (cell, formatterParams, onRendered) {
					cell.getElement().style.fontWeight = 'bold';
					cell.getElement().style.color = 'green';
					return cell.getValue();
				},
				cellClick:function(e, cell){
					const rowData = cell.getRow().getData();
					handleCellClick(rowData);
				},
			},
			{ title: t('COLLECTION_MANAGEMENT.잔액', { defaultValue: '잔액' }), field: 'balance_amount', headerHozAlign: 'center', hozAlign: 'right', width:150
				, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }
				, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } },
			{ title: t('COLLECTION_MANAGEMENT.지점정보', { defaultValue: '지점정보' }), field: 'branch_name', headerHozAlign: 'center', hozAlign: 'center', width: 200 },
			{ title: t('SMS_MANAGEMENT.생성일시', { defaultValue: '생성일시' }), field: 'last_modified_date', headerHozAlign: 'center', hozAlign: 'center', width:200,formatter:function(cell, formatterParams, onRendered){
				var value = cell.getValue();
				value = moment(value).format("DD/MM/YYYY HH:mm:ss");
				return value;
			} },
			{ title: t('COLLECTION_MANAGEMENT.비고', { defaultValue: '비고' }), field: 'remark', headerHozAlign: 'center', hozAlign: 'center', width:300 },
		];
	}
	const [columns, setColumns]                 = useState(titleColunms(t));

	// Filter 값에 따른 Tabulator 변화가 일어나는 함수
	const updateFilter = () => {
		if (tableRef.current) {
			tableRef.current.setFilter(filterField, filterType, filterValue);
		}
	};

	// value값을 입력할 때마다 해당되는 Tabulator가 화면에 보이도록 함수호출하는 부분
	const handleKeyUp = () => {
		updateFilter();
	};


	// 화면 UI
	return (
		<>
			<CustomToast show={toast} setToast={setToast} text={text} />
			<Card style={{ height: '100%' }}>
				<Card.Header><strong>{t('PREFERENCES.모계좌 관리', { defaultValue: '모계좌 관리' })}</strong></Card.Header>
				<Card.Body className='responsive-card-body'>
					<div className="panel-body">
						<div className="row ms-0">

								<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
									<label className="form-label" htmlFor="acct_nickname_id">
										<i className="bi bi-pen"></i> {t('COLLECTION_MANAGEMENT.계좌번호', { defaultValue: '계좌번호' })}
									</label>
									<input className="form-control" type="text" id="acct_no_id" value={accountNoId} onChange={handleChangeAccountNo} />
								</div>

								<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
									<label className="form-label" htmlFor="acct_nickname_id">
										<i className="bi bi-pen"></i> {t('LOAN_APPLICATION.지점', { defaultValue: '지점' })}
									</label>
									<select onChange={handleChangeBranch} value={selectBranch} className="form-select" id="site_code_id">
										{branchType === 'HEAD' 
											? <option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
											: ''
										}
										{selectOptions1.map((option, index) => (
											<option key={index} value={option[0]}>
												{/* {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })} */}
												{option[1]}											
											</option>
										))}
									</select>
								</div>

								<div className="form-group col-lg-7 col-md-12 col-xs-12"></div>

								<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
									<div className="mb-3"></div>
									<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
								</div>

								<div className="mt-3 mb-3 ps-0">
									<i id="filter-icon" className="cursor-pointer fa fa-plus-square" data-bs-toggle="collapse" href="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></i>
									<span> Filter</span>
								</div>

								<div className="collapse show" id="collapseExample">
									<div className="row">
										<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
											<select 
												id="filter-field" 
												className="form-select col-sm-3" 
												value={filterField}
												onChange={(e) => setFilterField(e.target.value)}
											>								
												
												<option value="bank_name">{t('COLLECTION_MANAGEMENT.은행', { defaultValue: '은행' })}</option>
												<option value="account_no">{t('COLLECTION_MANAGEMENT.계좌번호', { defaultValue: '계좌번호' })}</option>
												<option value="remark">{t('COLLECTION_MANAGEMENT.비고', { defaultValue: '비고' })}</option>

											</select>
										</div>
							
										<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
											<select 
												id="filter-type" 
												className="form-select col-sm-3"
												value={filterType}
												onChange={(e) => setFilterType(e.target.value)}
											>
												<option value="like">LIKE</option>
												<option value="=">=</option>
												<option value="<">&lt;</option>
												<option value="<=">&le;</option>
												<option value=">">&gt;</option>
												<option value=">=">&ge;</option>
												<option value="!=">!=</option>
											</select>
										</div>
							
										<div className="form-group col-lg-8 col-md-12 col-xs-12 ps-0 mb-3 rounded-2">
											<input 
												id="filter-value" 
												type="text" 
												className="form-control col-sm-6" 
												name="filter-value" 
												placeholder={t('COMMON.검색할 내용을 입력하세요', { defaultValue: '검색할 내용을 입력하세요' })}
												value={filterValue}
												onChange={(e) => setFilterValue(e.target.value)}
												onKeyUp={handleKeyUp}
											/>
										</div>
									</div>
								</div>
							</div>
						{/* </form> */}
					</div>

					{/* 로딩 관련 gif */}
					{loading && 
						<div
							style={{
								position: 'fixed',
								top: '50%',
								left: '55%',
								transform: 'translate(-50%, -50%)',
								zIndex: 9999,
							}}
						>
							<img src={loader} alt="Loading..." />
						</div>
					}

					{/* Tabulator */}
					<div id="tabulator-total-info" className='d-flex justify-content-end fw-bold'>{t(`LOAN_APPLICATION.총 {{count}}건`, { count: totalCount, defaultValue: '총 {{count}}건' })}</div>
					<ReactTabulator
						key         = {i18n.language + JSON.stringify(columns) + JSON.stringify(options)} // 언어 변경 및 옵션 변경에 따라 컴포넌트 리렌더링
						onRef       = {(r) => (tableRef.current = r.current)}
						columns     = {columns}
						options     = {loading ? loadingOptions : options} // 로딩 중일 때는 이전의 pagination 관련 정보를 유지하고 데이터를 변경하지 않도록 함
						placeholder = "No Data Found"
						className   = "responsive-tabulator"
					/>
				</Card.Body>

				<div className="card-footer d-flex justify-content-start mt-auto">
					<button type="button" className="btn btn-outline-info mb-1 me-1 w-auto" onClick={handleButtonClick}>{t('COLLECTION_MANAGEMENT.계좌등록', { defaultValue: '계좌등록' })}</button>
					<button type="button" className="btn btn-outline-info mb-1 me-1 w-auto" onClick={handleAccountApi}>{t('COLLECTION_MANAGEMENT.잔액조회', { defaultValue: '잔액조회' })}</button>
				</div>
				<Acct_001_01 showModal={showModal} handleClose={handleClose} BranchCodeOptions={BranchCodeOptions} BankCodeOptions={BankCodeOptions} DetailData={detailData.length > 0 ? detailData[0] : null} />
			</ Card>
		</>
	);
};

export default Acct001;